/*
--------------------------------------
 Fingerprinting library
--------------------------------------
 */

import Fingerprint from 'fingerprintjs2';

export const fingerprint = {

    methods: {

        generateFingerprint(callback) {

            // Asynchronous execution!
            return Fingerprint.get(function (components) {
                let values = components.map(function (component) {
                    return component.value
                })

                let result = Fingerprint.x64hash128(values.join(''), 31);

                callback({'result': result, 'components': components});

            }.bind(this));
        }
    },
};

